import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4e62e282"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "BigPlaceholder P-Rel" }
const _hoisted_2 = { class: "BigContainer" }
const _hoisted_3 = {
  key: 0,
  class: "BigLoading"
}
const _hoisted_4 = { class: "P1em" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }),
  /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }),
  /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" })
], -1))
const _hoisted_6 = {
  key: 0,
  class: "H-Auto F2em color4 O-25"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  class: "BG1 Shadow2 BGBlur",
  style: {"justify-content":"center"}
}
const _hoisted_9 = ["ToolTip"]
const _hoisted_10 = {
  key: 0,
  class: "D-Flex H-100 color2 O-50"
}
const _hoisted_11 = { class: "M-Auto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CookiesLoading = _resolveComponent("CookiesLoading")!
  const _component_WhatsappBuuble = _resolveComponent("WhatsappBuuble")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.Loading.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", null, [
                _createElementVNode("div", null, [
                  _createVNode(_component_CookiesLoading)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["BigBody", _ctx.FillBodyHeight])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", {
              class: "W-100 D-Flex FlexWrap H-Auto CardsHolder",
              style: _normalizeStyle([{"justify-content":"center"}, [_ctx.ViewType === 'GRID' ? 'gap: 2em 1em;' : '', _ctx.ViewType === 'Tiles' ? 'gap: 1em;' : '']])
            }, [
              (_ctx.CookiesData.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.Translate('No Data')), 1))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.CookiesData as Array<Catalog>), (catalog) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: catalog.ID,
                  onClick: ($event: any) => (_ctx.$router.push('/Catalogs/ViewCatalog/' + catalog.ID)),
                  class: "CatalogImage D-Flex Pointer",
                  style: _normalizeStyle('background-image: url(' + _ctx.DefaultImageHandler(catalog.ImgUrl) + ')')
                }, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("span", {
                      ToolTip: catalog.Name,
                      class: "M-Auto F-Bold P_5em color3",
                      style: {"font-size":"0.65em","white-space":"nowrap"}
                    }, _toDisplayString(catalog.Name), 9, _hoisted_9)
                  ])
                ], 12, _hoisted_7))
              }), 128))
            ], 4)
          ]),
          (!_ctx.CatalogAvailable && _ctx.Loading.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.ErrorText), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])
    ]),
    _createVNode(_component_WhatsappBuuble)
  ], 64))
}